<main class="login-container">
  <!-- Replaced video with GIF -->
  <div class="background-gif"></div>

  <div class="content-wrapper">
    <div class="login-card">
      <div class="logo-container">
        <img src="assets/images/Logo/login-logo.svg" alt="CSQ Logo" class="logo">
      </div>
      <h1 class="welcome-text">Experience Portal</h1>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <div class="form-group">
          <label for="email">Email</label>
          <div class="input-container">
            <img src="assets/images/sms.svg" alt="email icon" class="icon">
            <input id="email" type="email" formControlName="email" placeholder="Enter your email"
              [class.invalid-input]="isInvalid('email')" [class.disabled]="isLoading" />
          </div>
          <div class="login-error-message-container">
            <div class="login-error-message" *ngIf="showError('email', 'required')">
              Please enter a email address.
            </div>
            <div class="login-error-message" *ngIf="showError('email', 'email') || showError('email', 'invalidEmail')">
              Please enter a valid email address.
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <div class="password-input-container">
            <div class="input-container">
              <img src="assets/images/lock.svg" alt="password icon" class="icon" />
              <input [type]="hidePassword ? 'password' : 'text'" id="password" formControlName="password"
                placeholder="Enter your password" [class.invalid-input]="isInvalid('password')"
                [class.disabled]="isLoading" />
            </div>

            <button *ngIf="passwordHasValue && !isLoading" type="button" class="password-toggle"
              (click)="togglePasswordVisibility()" aria-label="Toggle password visibility">
              <i class="fa icon-pass" [ngClass]="hidePassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>

          <div class="login-error-message-container">
            <div class="login-error-message" *ngIf="showError('password', 'required')">
              Please enter your password.
            </div>
          </div>
        </div>

        <div class="forgot-container">
          <div class="remember-container">
            <input type="checkbox" id="rememberMe" formControlName="rememberMe" class="remember-checkbox"
              [class.disabled]="isLoading" (change)="onRememberMeChange()">
            <label for="rememberMe" class="remember-text">Remember me</label>
          </div>
          <div class="forgot-password">
            <a [routerLink]="!isLoading ? '/auth/forgot-password' : null" [class.disabled]="isLoading"
              (click)="isLoading && $event.preventDefault()">
              Forgot password?
            </a>
          </div>
        </div>

        <button type="submit" class="login-button" [class.disabled]="isLoading">
          <span *ngIf="!isLoading">Login</span>
          <div *ngIf="isLoading" class="button-loader">
            <div class="spinner"></div>
            <span>Logging in...</span>
          </div>
        </button>
      </form>
    </div>
  </div>

  <p class="login-subtext footer-text">
    Should you require immediate assistance, please contact CSQ at
    <a href="tel:1800798488" class="contact-phone">1800 798 488</a> or
    <br>
    email us at <a href="mailto:constructionpathways@csq.org.au"
      class="contact-email">constructionpathways&#64;csq.org.au</a>
  </p>
</main>